









import VueOptions from '@utils/VueOptions'
import AlertBar from '@components/AlertBar'

settings =
  vue:
    name: 'EventListAlertBar'
    props: ['events']
    components: { AlertBar }
    data: ->
      eventWithDraftOffer: null
    methods: 
      alert: () ->
        return @promptToSubmitOffer(@eventWithDraftOffer) if @eventWithDraftOffer
        return null
      promptToSubmitOffer: (event) ->
        {
          id: event.id
          type: 'cta'
          message: "Organizer is waiting. Submit your offer for #{event.name}!"
          button: { label: 'View Event', nav: { name: 'EventShowPage', params: { eventId: event.id, tab: 'overview' } } } 
          dismissable: false
        }
    mounted: ->
      @eventWithDraftOffer ||=  e for e in @events when e.offer_drafted

export default VueOptions.vue settings
